export const SET_STATE = 'poolLeague/SET_STATE';

export const SET_DISPLAYED_DIV = 'poolLeague/SET_DISPLAYED_DIV';

export const SET_LEAGUE_TABLE_SORT_DIRECTION = 'poolLeague/SET_LEAGUE_TABLE_SORT_DIRECTION';
export const SET_LEAGUE_TABLE_SORT_OPTION = 'poolLeague/SET_LEAGUE_TABLE_SORT_OPTION';
export const CLEAR_LEAGUE_SORT = 'poolLeague/CLEAR_LEAGUE_SORT';

export const SET_FIXTURE_FILTER = 'poolLeague/SET_FIXTURE_FILTER';
export const CLEAR_FIXTURE_FILTER = 'poolLeague/CLEAR_FIXTURE_FILTER';


/** WEBPACK FOOTER **
 ** ./src/constants/actions.js
 **/